import { learner } from './reducers';
export default learner;
